import { render, staticRenderFns } from "./ReviewYourAnswersAFF.vue?vue&type=template&id=816e2d16"
import script from "./ReviewYourAnswersAFF.vue?vue&type=script&lang=ts"
export * from "./ReviewYourAnswersAFF.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports